import React from 'react';
import PropTypes from 'prop-types';
import EventCard from './EventCard';

// Список мероприятий, сгруппированный по дням.
export default function EventsList({ groups, getImageUrl, onEdit }) {
    if (groups.length === 0) {
        return (
            <div className="t-caption" style={{ textAlign: 'center', padding: '48px 0' }}>
                Нет мероприятий. Добавьте первое мероприятие для этой смены.
            </div>
        );
    }

    return (
        <>
            {groups.map(({ dateKey, dayLabel, events }) => (
                <div key={dateKey}>
                    <div className="ev-day">{dayLabel}</div>
                    <div className="ev-grid">
                        {events.map(event => (
                            <EventCard
                                key={event.id}
                                event={event}
                                imageUrl={getImageUrl(event)}
                                onClick={() => onEdit(event)}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </>
    );
}

EventsList.propTypes = {
    groups: PropTypes.arrayOf(PropTypes.shape({
        dateKey: PropTypes.string.isRequired,
        dayLabel: PropTypes.string.isRequired,
        events: PropTypes.array.isRequired
    })).isRequired,
    getImageUrl: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired
};
